import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { TopUpErrorDescription, TopUpErrorHeader } from '../../models/topup-model';
import { MatButton } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-topup-info-dialog',
  templateUrl: './topup-info-dialog.component.html',
  styleUrls: ['./topup-info-dialog.component.scss'],
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatButton,
  ],
})
export class TopUpInfoDialogComponent {
  public header: string;
  public description: string;

  constructor(@Inject(MAT_DIALOG_DATA) private errCode: string) {
    this.header = TopUpErrorHeader[errCode];
    this.description = TopUpErrorDescription[errCode];
  }
}
